import React, {
  createContext,
  useState,
  useCallback,
  useMemo,
  useContext,
  ReactNode,
} from 'react';

const ExportTeamButtonContext = createContext({
  exportEnabled: true,
  enableExport: () => {},
  disableExport: () => {},
});

export const useTeamExportButton = () => useContext(ExportTeamButtonContext);

export const ExportTeamButtonContextProvider = ({
  children,
}: {
  children?: ReactNode | undefined;
}) => {
  const [exportEnabled, setExportEnabled] = useState(true);

  const enableExport = useCallback(() => setExportEnabled(true), []);
  const disableExport = useCallback(() => setExportEnabled(false), []);

  const value = useMemo(
    () => ({ exportEnabled, enableExport, disableExport }),
    [exportEnabled, enableExport, disableExport]
  );

  return (
    <ExportTeamButtonContext.Provider value={value}>
      {children}
    </ExportTeamButtonContext.Provider>
  );
};
